/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PhoneNumberInput } from './PhoneNumberInput';
import {
    PhoneNumberInputFromJSON,
    PhoneNumberInputFromJSONTyped,
    PhoneNumberInputToJSON,
    PhoneNumberInputToJSONTyped,
} from './PhoneNumberInput';

/**
 * Local user creation request
 * @export
 * @interface CreateLocalUserRequest
 */
export interface CreateLocalUserRequest {
    /**
     * User email address
     * @type {string}
     * @memberof CreateLocalUserRequest
     */
    email?: string;
    /**
     * User first name
     * @type {string}
     * @memberof CreateLocalUserRequest
     */
    firstName?: string;
    /**
     * User last name
     * @type {string}
     * @memberof CreateLocalUserRequest
     */
    lastName?: string;
    /**
     * Preferred username/display name for the user (optional, defaults to email if not provided)
     * @type {string}
     * @memberof CreateLocalUserRequest
     */
    preferredUsername?: string;
    /**
     * Phone numbers for the user (optional, supports multiple phone numbers)
     * @type {Array<PhoneNumberInput>}
     * @memberof CreateLocalUserRequest
     */
    phoneNumbers?: Array<PhoneNumberInput>;
    /**
     * Extended metadata/attributes for the user (optional, JSON object for custom fields)
     * @type {{ [key: string]: any; }}
     * @memberof CreateLocalUserRequest
     */
    metadata?: { [key: string]: any; };
    /**
     * Tenant ID where user will be created
     * @type {string}
     * @memberof CreateLocalUserRequest
     */
    tenantId?: string;
    /**
     * Role ID to assign to user (direct role assignment)
     * @type {string}
     * @memberof CreateLocalUserRequest
     */
    roleId?: string;
    /**
     * Role name to assign to user (alternative to roleId)
     * @type {string}
     * @memberof CreateLocalUserRequest
     */
    roleName?: string;
    /**
     * Group ID to add user to (group-based role assignment)
     * @type {string}
     * @memberof CreateLocalUserRequest
     */
    groupId?: string;
    /**
     * Group name to add user to (alternative to groupId)
     * @type {string}
     * @memberof CreateLocalUserRequest
     */
    groupName?: string;
    /**
     * Preferred timezone for the user (overrides tenant default)
     * @type {string}
     * @memberof CreateLocalUserRequest
     */
    preferredTimezone?: string;
    /**
     * Whether the initial password should be temporary (force reset)
     * @type {boolean}
     * @memberof CreateLocalUserRequest
     */
    temporaryPassword?: boolean;
}

/**
 * Check if a given object implements the CreateLocalUserRequest interface.
 */
export function instanceOfCreateLocalUserRequest(value: object): value is CreateLocalUserRequest {
    return true;
}

export function CreateLocalUserRequestFromJSON(json: any): CreateLocalUserRequest {
    return CreateLocalUserRequestFromJSONTyped(json, false);
}

export function CreateLocalUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLocalUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'preferredUsername': json['preferredUsername'] == null ? undefined : json['preferredUsername'],
        'phoneNumbers': json['phoneNumbers'] == null ? undefined : ((json['phoneNumbers'] as Array<any>).map(PhoneNumberInputFromJSON)),
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'roleId': json['roleId'] == null ? undefined : json['roleId'],
        'roleName': json['roleName'] == null ? undefined : json['roleName'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'preferredTimezone': json['preferredTimezone'] == null ? undefined : json['preferredTimezone'],
        'temporaryPassword': json['temporaryPassword'] == null ? undefined : json['temporaryPassword'],
    };
}

export function CreateLocalUserRequestToJSON(json: any): CreateLocalUserRequest {
    return CreateLocalUserRequestToJSONTyped(json, false);
}

export function CreateLocalUserRequestToJSONTyped(value?: CreateLocalUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'preferredUsername': value['preferredUsername'],
        'phoneNumbers': value['phoneNumbers'] == null ? undefined : ((value['phoneNumbers'] as Array<any>).map(PhoneNumberInputToJSON)),
        'metadata': value['metadata'],
        'tenantId': value['tenantId'],
        'roleId': value['roleId'],
        'roleName': value['roleName'],
        'groupId': value['groupId'],
        'groupName': value['groupName'],
        'preferredTimezone': value['preferredTimezone'],
        'temporaryPassword': value['temporaryPassword'],
    };
}

